import { inject, Service } from '@angular/core';
import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmComponent } from '../components/confirm/confirm.component';
import { YesNoCancelComponent } from '../components/yes-no-cancel/yes-no-cancel.component';
import { MessageComponent } from '../components/message/message.component';
import { NotificationComponent } from '../components/notification/notification.component';

@Service()
export class ConfirmService {
    fasTimes = faTimes;
    fasCheck = faCheck;
    fasTrashAlt = faTrashAlt;

    private modalService = inject(NgbModal);
    constructor() { }

    confirm(title?: string | null,
        prompt?: string,
        okBtnText?: string,
        cancelBtnText?: string,
        okBtnIcon?: IconDefinition,
        cancelBtnIcon?: IconDefinition,
        okBtnClass?: string,
        cancelBtnClass?: string): Promise<any> {
        const modal = this.modalService.open(ConfirmComponent, { centered: true });
        if (title) {
            modal.componentInstance.title = title;
        }
        if (prompt) {
            modal.componentInstance.prompt = prompt;
        }
        if (cancelBtnClass) {
            modal.componentInstance.cancelBtnClass = cancelBtnClass;
        }
        if (okBtnClass) {
            modal.componentInstance.okBtnClass = okBtnClass;
        }
        if (cancelBtnText) {
            modal.componentInstance.cancelBtnText = cancelBtnText;
        }
        if (okBtnText) {
            modal.componentInstance.okBtnText = okBtnText;
        }
        modal.componentInstance.cancelBtnIcon = cancelBtnIcon || this.fasTimes;
        modal.componentInstance.okBtnIcon = okBtnIcon || this.fasCheck;

        return modal.result;
    }

    notify(prompt?: string,
        okBtnText?: string,
        okBtnIcon?: IconDefinition,
        okBtnClass?: string): Promise<any> {
        const modal = this.modalService.open(NotificationComponent, { centered: true });
        if (prompt) {
            modal.componentInstance.prompt = prompt;
        }
        if (okBtnClass) {
            modal.componentInstance.okBtnClass = okBtnClass;
        }
        if (okBtnText) {
            modal.componentInstance.okBtnText = okBtnText;
        }
        modal.componentInstance.okBtnIcon = okBtnIcon || this.fasCheck;

        return modal.result;
    }

    delete(title?: string,
        prompt?: string,
        okBtnText?: string,
        cancelBtnText?: string,
        okBtnIcon?: IconDefinition,
        cancelBtnIcon?: IconDefinition,
        okBtnClass?: string,
        cancelBtnClass?: string): Promise<any> {
        return this.confirm(title, prompt, okBtnText || `Delete`, cancelBtnText, okBtnIcon || this.fasTrashAlt, cancelBtnIcon, okBtnClass || 'btn-danger', cancelBtnClass);
    }

    yesNoCancel(prompt?: string,
        yesBtnText?: string,
        noBtnText?: string,
        cancelBtnText?: string): Promise<any> {
        const modal = this.modalService.open(YesNoCancelComponent, { centered: true });
        if (prompt) {
            modal.componentInstance.prompt = prompt;
        }
        if (yesBtnText) {
            modal.componentInstance.yesBtnText = yesBtnText;
        }
        if (noBtnText) {
            modal.componentInstance.noBtnText = noBtnText;
        }
        if (cancelBtnText) {
            modal.componentInstance.cancelBtnText = cancelBtnText;
        }
        return modal.result;
    }

    message(title?: string,
        prompt?: string): Promise<any> {
        const modal = this.modalService.open(MessageComponent, { modalDialogClass: 'modal-dialog-centered' });
        if (title) {
            modal.componentInstance.title = title;
        }
        if (prompt) {
            modal.componentInstance.prompt = prompt;
        }
        return modal.result;
    }

}
